module.exports = __webpack_public_path__ + "static/media/email_sent.2ae39c7e.svg";